import React, { useRef, useState } from 'react'
import Patient from '../../../images/patient.svg';
import Provider from '../../../images/provider.svg';
import PrimaryNavLink from './primary-nav-link';
import ChevronDown from '../../../images/chevron_down_black.svg';
import ChevronUp from '../../../images/chevron_up_black.svg';
import useDelayUnmount from '../../../hooks/useDelayUnmount';
import useClickOutside from '../../../hooks/useClickOutside';

const LoginDropdown = () => {
  const [isMounted, setIsMounted] = useState(false);
  const showDropdown = useDelayUnmount({isMounted, delayTime: 250});
  const toggleDropdown = () => setIsMounted(prevOpen => !prevOpen);

  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);
  useClickOutside({ref: dropdownRef, triggerRef, setOpen: setIsMounted});

  return (
    <div className='login nav-dropdown-trigger'>
      <div ref={triggerRef} className='toggle' onClick={toggleDropdown}>
        Login <img className='chevron' src={isMounted ? ChevronUp : ChevronDown} alt={isMounted ? "arrow up" : "arrow down"} />
        <hr className={isMounted ? 'selected-line' : ''} />
      </div>
      {showDropdown &&
        <div ref={dropdownRef} className={`nav-dropdown ${isMounted ? 'mount' : 'unmount'}`}>
          <div className='nav-dropdown-main-links-wrapper'>
              <PrimaryNavLink id="tag-patient-portal-link" label="Patient" link="https://patient.pathapplication.com/" image={Patient} altText="an icon of a person" />
              <PrimaryNavLink id="tag-provider-portal-link" label="Provider" link="https://provider.pathapplication.com/signin" image={Provider} altText="an icon of 2 people" />
          </div>
        </div>
      }
    </div>
  )
}

export default LoginDropdown
